import {createStore, applyMiddleware} from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from './reducers';


export default function configureStore(initialState) {
  let middleware = process.env.NODE_ENV !== 'production' ?
    applyMiddleware(thunk, logger) : applyMiddleware(thunk);

  return createStore(rootReducer, initialState, middleware);
}


// WEBPACK FOOTER //
// ./src/store.js